import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { storeTrainingId } from './core/training-id-storage';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private location: Location) {
    this.captureTrainingId();
  }

  /**
   * Corre antes de la navegación inicial del router, así cualquier ruta puede
   * leer el id después. Se limpia sólo el query param: borrar el path entero
   * sacaría al solicitante de la pantalla en la que está.
   */
  private captureTrainingId(): void {
    const trainingId = new URLSearchParams(window.location.search).get(
      'trainingId'
    );
    if (!trainingId) {
      return;
    }
    storeTrainingId(trainingId);
    this.location.replaceState(window.location.pathname);
  }
}
